// Audio handler for WF1999 Classified Archive
import {getAppState} from './1999-state';

export const MEDIA_DIR = (window.PageData.MediaDir || '/videos/1999/message-board') + '/';
export const DecryptSuccessAudio = new Audio(MEDIA_DIR+'decrypt-success.mp3');

export function playSound(sound, volume=1.0) {
    if (sound && sound.play) {
        if (sound.playing) sound.pause();
        sound.currentTime = 0;
        sound.volume = volume * getAppState().volume;
        sound.play();
    }
}
export function stopSound(sound) {
    if (sound) {
        sound.pause();
        sound.currentTime = 0;
    }
}
